<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'TheIntegration',
}
</script>

<style scoped></style>
